export const formatDate = (dt) => {
  if (!dt) return "-";
  const d = new Date(dt);
  if (isNaN(d.getTime())) return dt;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const formatTime = (dt) => {
  if (!dt) return "-";
  if (String(dt).includes("T00:00:00")) return "-";
  const d = new Date(String(dt).replace(/Z$/, ''));
  if (isNaN(d.getTime())) return dt;
  return d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
};

export const formatDateTime = (dt) => {
  if (!dt) return "-";
  const d = new Date(String(dt).replace(/Z$/, ''));
  if (isNaN(d.getTime())) return dt;
  return d.toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
  });
};
